module.exports = __webpack_public_path__ + "static/img/smart4.2ef47be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/smart/smart4.jpg
// module id = 4CyI
// module chunks = 1